import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    code: yup.string().trim().typeError(errors.REQUIRED).required(),
    process: yup.object().shape({
      id: yup.string().trim().typeError(errors.REQUIRED).required(),
    }),
  });
};

export default validation;
